import { graphql, useStaticQuery } from 'gatsby';
import useLanguageData from '@utils/useLanguageData';

export const query = graphql`
  query getSiteBannerData {
    allPrismicEcommerceSiteBanner(sort: { data: { banner_config: { priority: DESC } } }) {
      nodes {
        lang
        data {
          banner_config {
            background_color
            banner_link {
              text
            }
            banner_text {
              richText
            }
            promotion_id {
              text
            }
            promotion_name {
              text
            }
            counter_background_color
            counter_text_color
            counter_date
            country_code {
              text
            }
            google_analytics_id {
              text
            }
            highlight_background_color
            highlight_text_color
            trustpilot
            logged_in
            new_window
            page_path_excludes {
              text
            }
            page_path_includes {
              text
            }
            priority
            text_color
          }
        }
      }
    }
  }
`;

export const getSiteBannerData = () => {
  const { allPrismicEcommerceSiteBanner } = useStaticQuery(query);
  const { nodes } = allPrismicEcommerceSiteBanner;
  const { pageData: banners } = useLanguageData(nodes);

  if (!banners) {
    return [];
  }

  return banners.data.banner_config;
};
